<template>
    <rkm-overlay>
        <template v-if="isAlmoxarifado">
            <rkm-layout-body :title="title">
                <template v-slot:actions>
                    <rkm-button
                        @click="$router.push({ name: 'almoxarifado-entrada-create' })"
                        authorize="store-almoxarifado-entrada"
                        color="primary"
                    >
                        Cadastrar entrada
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body :title="title">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>almoxarifado</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/entrada/List'

import { mapGetters } from 'vuex'

import tipoSetor from '@/enums/cadastro/estabelecimento/setorTipo'

export default {
    components: { List },
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto' }),
        isAlmoxarifado() {

            return this.centroCusto.setor.tipoId == tipoSetor.ALMOXARIFADO
        }
    },
    data: () => ({
        title: 'Lista de entrada',
        enums: { tipoSetor }
    })
}
</script>